export default __webpack_public_path__ + "static/media/defaultLogin.6f5b602b.jpg";